import * as React from 'react'
import { SearchX } from 'lucide-react'

import { Button } from '@modules/shadcn/ui/Button/Button'

/**
 * どのルートにも一致しないURL（React Routerの404）で出す表示。rootの `ErrorBoundary` から描く。
 *
 * 以前はrootの `ErrorBoundary` が何も描かず、存在しないURLを開くと真っ白になっていた。
 * 案件単位の旧AIカラー詳細（`/ai-color-simulation/<案件ID>`）を廃止してルートごと消したときに、
 * そのURLを開いた人が何が起きたか分かるように置いた。文言と構成は権限なし表示（`PlanNoAccessPage`）と
 * adminの `RouteErrorScreen` に合わせる。
 *
 * ErrorBoundaryの中はレイアウト（サイドバー）もルーターの状態も当てにできないので、
 * 戻る導線は `Link` ではなく `<a>` にする（adminの `RouteErrorScreen` と同じ）。
 */
export const NotFoundPage: React.FC = () => (
  <div className="flex w-full justify-center px-4 py-16" data-testid="not-found-page">
    <div className="flex max-w-md flex-col items-center gap-3 text-center">
      <SearchX className="text-muted-foreground" size={32} aria-hidden />
      <h1 className="text-lg font-semibold">ページが見つかりません</h1>
      <p className="text-sm text-muted-foreground">
        URLが間違っているか、ページが削除された可能性があります。
      </p>
      <Button asChild variant="outline" className="mt-2">
        <a href="/">ホームに戻る</a>
      </Button>
    </div>
  </div>
)

NotFoundPage.displayName = 'NotFoundPage'
